import { render, staticRenderFns } from "./DataComponentModelList.vue?vue&type=template&id=41c9cc23&scoped=true&"
import script from "./DataComponentModelList.vue?vue&type=script&lang=js&"
export * from "./DataComponentModelList.vue?vue&type=script&lang=js&"
import style0 from "./DataComponentModelList.vue?vue&type=style&index=0&id=41c9cc23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9cc23",
  null
  
)

export default component.exports